// Keep view-only data and fields belonging to other steps out of the API DTO.
// In particular, an unfilled date input is "" in React, not a JSON DateTime.
import {upperCareerName} from './careerNames';
export function stepPayload(stage,form,lang,consent=false) {
  const common={surum:form.surum,dil:lang};
  switch(stage){
    case 'citizenship':
      return {...common,tcVatandasiMi:form.tcVatandasiMi,vatandaslikUlkeKodu:form.tcVatandasiMi===true?'TR':form.vatandaslikUlkeKodu};
    case 'identity':
      return {...common,adi:upperCareerName(form.adi).trim(),soyadi:upperCareerName(form.soyadi).trim(),dogumTarihi:form.dogumTarihi||null,kimlikNo:form.kimlikNo,kimlikBelgeTuru:form.kimlikBelgeTuru,cinsiyet:form.cinsiyet,dogumYeri:form.dogumYeri};
    case 'contact':
      return {...common,telefon:form.telefon,ikametUlkeKodu:form.ikametUlkeKodu,ikametSehir:form.ikametSehir,ikametIlce:form.ikametIlce,kisiIlId:form.ikametUlkeKodu==='TR'?form.kisiIlId:null,kisiIlceId:form.ikametUlkeKodu==='TR'?form.kisiIlceId:null,adres:form.adres};
    case 'education':
    case 'experience':
      // Records are saved through their own endpoints before advancing the step.
      return common;
    case 'skills':
      return {...common,ozet:form.ozet,ulkeler:form.ulkeler,kanGrubu:form.kanGrubu,maasBeklenti:form.maasBeklenti,ehliyet:form.ehliyet,askerlikDurumu:form.askerlikDurumu,medeniDurumu:form.medeniDurumu,...(form.seyahatDurumu!==undefined?{seyahatDurumu:form.seyahatDurumu===''?null:form.seyahatDurumu}:{})};
    case 'review':
      return {...common,beyan:consent,kvkk:!!form.kvkk,onayMetniId:form.onayMetniId};
    default:
      throw new Error('invalidStep');
  }
}
